import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import type { ApiError, ApiResponse } from "../../../types/apiResponse";
import { createContract } from "../apis/createContract";
import type { UploadContractData } from "../types/uploadContract";

export const useCreateContract = (): UseMutationResult<ApiResponse, ApiError, UploadContractData> => {
    return useMutation({
        mutationFn: createContract,
    })
}
